<template>
    <div class="sa-prescrizione-card">
        <div class="sa-prescrizione-header">
            <div class="header-left">
                <div class="sa-prescrizione-header-title">Terapia motoria</div>
                <div class="sa-prescrizione-header-subtitle">Prescrizione</div>
            </div>
            <!-- <div class="header-right">
                <div style="height: 100% !important; margin-bottom: 2px">
                    <div class="sa-prescrizione-header-title" style="margin-bottom: 2px; font-size: 12px">Modalita Somministrazione</div>
                    <select class="sa-prescrizione-input-header" v-model="viaSomministrazione">
                        <option v-for="misura of prescrizioneModalitaSomministrazioneOptions" :key="misura.id" :value="misura.nome">{{ misura.nome }} <span v-if="!!misura.descrizione"></span></option>
                    </select>
                </div>
            </div> -->
        </div>

        <div class="sa-prescrizione-body">
            <!-- Abbiamo aggiunto un po' di stile al contenitore principale dell'item per separare visivamente ogni esercizio -->
            <div v-for="(item, index) in prescription.components" :key="index" class="sa-prescrizione-item sa-prescrizione-item-farmaco" style="display: flex; flex-direction: column; background: #f8fafc; padding: 15px; border-radius: 8px; margin-bottom: 15px; border: 1px solid #e2e8f0">
                <!-- PRIMA RIGA: Tutti i campi di input e il cestino -->
                <div style="display: flex; align-items: center; width: 100%; gap: 10px">
                    <div class="sa-prescrizione-input-group" style="flex: 0">
                        <span style="display: flex; display: inline-flex; align-items: center; justify-content: center; width: 20px; height: 20px; border: 1px solid var(--bg-sidebar); border-radius: 50%; color: var(--bg-sidebar); font-size: 11px; font-weight: bold; flex-shrink: 0; line-height: 1">{{ index + 1 }}</span>
                    </div>

                    <div class="sa-prescrizione-input-group" style="flex: 3">
                        <label class="sa-label-data">Categoria</label>
                        <div class="sa-prescrizione-search-wrapper">
                            <b-form-select v-model="item.categoria" :options="videoCategoriaOptions" @change="onChangeCategoria(item)" value-field="categoria" text-field="categoria"></b-form-select>
                        </div>
                    </div>

                    <div class="sa-prescrizione-input-group" style="flex: 3">
                        <label class="sa-label-data">Video</label>
                        <div class="sa-prescrizione-search-wrapper">
                            <b-form-select v-model="item.idVideo" :options="item.videoOptions" value-field="id" text-field="nome" @change="onChangeVideo(item)"></b-form-select>
                        </div>
                    </div>

                    <div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
                        <label class="sa-label-data">Sessioni</label>
                        <input class="sa-prescrizione-input" type="number" v-model="item.sessioni" />
                    </div>

                    <div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
                        <label class="sa-label-data">Ripetizioni</label>
                        <input class="sa-prescrizione-input" type="number" v-model="item.ripetizioni" />
                    </div>

                    <div class="sa-prescrizione-input-group" style="flex: 1; min-width: 70px">
                        <label class="sa-label-data">Durata</label>
                        <input class="sa-prescrizione-input" type="number" v-model="item.durata" />
                    </div>

                    <button v-if="!item.veicolo" @click="removeComponent(index)" class="sa-prescrizione-btn-remove" style="margin-top: 20px">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>

                <!-- SECONDA RIGA: Il Video (appare solo se è in caricamento o è stato caricato) -->
                <div v-if="item.caricamentoVideo || item.videoUrlBlob" style="margin-top: 15px; padding-top: 15px; border-top: 1px dashed #cbd5e1; display: flex; flex-direction: column; align-items: flex-start; margin-left: 30px">
                    <!-- Messaggio di caricamento -->
                    <div v-if="item.caricamentoVideo" class="video-loading" style="color: #1e40af; font-size: 13px; font-weight: 500"><i class="fas fa-spinner fa-spin"></i> Scaricamento anteprima video...</div>

                    <!-- Box del video (dimensione fissa e angoli arrotondati) -->
                    <div v-if="item.videoUrlBlob" class="video-preview-container">
                        <span style="display: block; font-size: 12px; color: #64748b; margin-bottom: 4px; font-weight: 600">Anteprima Esercizio:</span>
                        <video :src="item.videoUrlBlob" controls style="width: 240px; height: auto; border-radius: 8px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); background-color: #000; outline: none; border: 2px solid #e2e8f0"></video>
                    </div>
                </div>
            </div>

            <button @click="onClickAggiungiFarmaco" class="sa-prescrizione-btn-add"><i class="fas fa-plus"></i> Aggiungi Esercizio alla prescrizione</button>
        </div>

        <div class="sa-prescrizione-footer">
            <div class="sa-prescrizione-total-text">
                <!-- Volume Finale: <span class="sa-prescrizione-total-value">{{ totalVolume }} ml</span> -->
            </div>
            <button @click="onClickConfermaPrescrizione" class="sa-prescrizione-btn-confirm">Conferma Prescrizione</button>
        </div>
    </div>
</template>

<script>
import toast from "../../../../template/layout/utility/sa-toast";
import MagazzinoMixins from "../../../magazzino/mixins/MagazzinoMixins";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazientePrescrizioneMixin from "../mixins/RsaPazientePrescrizioneMixin";
import axios from "axios";

export default {
    mixins: [MagazzinoMixins, RsaPazientePrescrizioneMixin, UtilityMixin],
    data() {
        return {
            pathresourceVideo: "/servizivideo",
            totalVolume: "",
            categoria: "",
            videoOptions: [],
            selectedIndex: null,
            viaSomministrazione: "Esercizio",
            prescriptionConfirm: null,
            prescrizione: null,
            videoCategoriaOptions: [],
            prescription: {
                components: [{ prescrizione: null, durata: 0, sessioni: 0, ripetizioni: 0, videoOptions: [] }],
            },
        };
    },
    mounted() {
        this.loadVideoCategorie();
    },
    methods: {
        onClickAggiungiFarmaco() {
            this.prescription.components.push({
                prescrizione: null,
                durata: 0,
                sessioni: 0,
                ripetizioni: 0,
                videoOptions: [],
            });
        },
        removeComponent: function (index) {
            this.prescription.components.splice(index, 1);
        },
        onClickConfermaPrescrizione(bvModalEvent) {
            bvModalEvent.preventDefault();
            /*     let validation = this.validazione();
            if (!validation.esito) {
                toast.validation(validation);
                return;
            } else {
                this.$emit("erroreValidazione");
            }
 */
            this.prescription.components.forEach((element) => {
                delete element.categoria;
                delete element.videoOptions;
                delete element.caricamentoVideo;
                delete element.videoUrlBlob;
            });
            this.$emit("confermaPrescrizioneEsercizi", this.prescription.components, { viaSomministrazione: this.viaSomministrazione });
            toast.success("Esercizi Confermati");
        },
        setEsercizi(prescrizioneFarmaci, jsonPrescrizione) {
            let components = JSON.parse(JSON.stringify(prescrizioneFarmaci));

            components.forEach((element) => {
                if (!element.videoOptions) element.videoOptions = [];
                if (!element.categoria) element.categoria = null;
                if (element.idVideo && this.videoOptions.length > 0) {
                    let videoTrovato = this.videoOptions.find((v) => v.id === element.idVideo);
                    if (videoTrovato) {
                        element.categoria = videoTrovato.categoria;
                        this.onChangeCategoria(element);
                        console.log(element);

                        this.onChangeVideo(element);
                    }
                }
            });

            this.prescription.components = components;
            this.jsonPrescrizione = jsonPrescrizione;
            this.viaSomministrazione = jsonPrescrizione.viaSomministrazione;
        },
        validazione() {
            let esito = true;
            let msg = "";
            if (this.viaSomministrazione == null) {
                msg += "Inserire Modalita Somministrazione #";
                esito = false;
            }
            this.prescription.components.forEach((farmaco, i) => {
                if (!farmaco.prescrizione || farmaco.prescrizione.trim() == "") {
                    msg += "Inserire farmaco valido, indice: " + (i + 1) + " #";
                    esito = false;
                }
                if (farmaco.quantita <= 0 && !isNaN(farmaco.quantita)) {
                    msg += "Inserire quantita valida, indice : " + (i + 1) + " #";
                    esito = false;
                }
                if (farmaco.unitaMisura == null) {
                    msg += "Inserire unita' misura valida, indice : " + (i + 1) + " #";
                    esito = false;
                }
            });

            return { esito: esito, msg: msg };
        },
        loadVideoCategorie() {
            UtilityMixin.methods.loadDataResources(this.pathresourceVideo, {}, this.resultResponseVideoCategorie, null);
        },
        resultResponseVideoCategorie(response) {
            this.videoCategoriaOptions = [];
            this.videoOptions = response.data.data.list;
            const categorie = [...new Set(response.data.data.list.map((item) => item.categoria))];
            this.videoCategoriaOptions = categorie.map((c) => ({
                categoria: c,
            }));
        },
        onChangeCategoria(value) {
            this.loadVideo(value);
        },
        loadVideo(item) {
            this.loadDataResources(
                this.pathresourceVideo,
                { categoria: item.categoria },
                (response) => {
                    let listaVideo = response.data.data.list;
                    listaVideo.unshift({ id: null, nome: "Seleziona..." });

                    this.$set(item, "videoOptions", listaVideo);
                },
                null,
            );
        },
        onChangeVideo(item) {
            console.log(item);
            let selected = item.videoOptions.find((element) => element.id === item.idVideo);
            console.log("selected", selected);
            if (selected) {
                item.prescrizione = selected.nome;
                this.loadStreamVideo(selected.id, item);
            }
        },
        loadStreamVideo(id, item) {
            this.$set(item, "caricamentoVideo", true);
            let link = process.env.VUE_APP_PATH_API + this.pathresourceVideo + "/video/" + id;
            axios
                .get(link, { responseType: "blob" })
                .then((response) => {
                    console.log("Dimensione video scaricato (byte):", response.data.size);
                    let urlBlob = URL.createObjectURL(response.data);
                    this.$set(item, "videoUrlBlob", urlBlob);
                })
                .catch((error) => {
                    console.error("Errore nel caricamento del video:", error);
                })
                .finally(() => {
                    this.$set(item, "caricamentoVideo", false);
                });
        },
    },
};
</script>

<style scoped>
.header-left {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 12px;
    height: 100%;
}

.sa-prescrizione-input-header {
    padding: 8px 12px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
    backdrop-filter: blur(6px);
}

.sa-prescrizione-input-header-custom {
    padding: 8px 12px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    background-color: rgba(255, 255, 255, 0.15);
    color: white;
    backdrop-filter: blur(6px);
    width: 50%;
}

.sa-prescrizione-input-header option {
    color: black;
}

.time-picker {
    min-width: 110px;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background: #ffffff;
    font-weight: 700;
    font-size: 14px;
    color: #0f172a;
}

.time-picker:focus-within {
    border-color: #1e40af;
    box-shadow: 0 0 0 2px rgba(30, 64, 175, 0.15);
}

.time-picker .mx-icon-calendar,
.time-picker .mx-icon-time {
    color: #1e40af;
}

.time-picker:hover {
    background: #f8fafc;
}

.sa-prescrizione-input-header-custom::placeholder {
    color: white;

    opacity: 1;
}
</style>
